import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, ElementRef, inject, Injector, Input } from '@angular/core'

import { ConversationStore } from '@app/modules/messaging/components/store/conversation.store'
import type { Conversation } from '@app/modules/messaging/models/conversation.model'
import type { Message } from '@app/modules/messaging/models/message.model'
import { ConversationUIService } from '@app/modules/messaging/services/conversation-ui.service'
import { Timespan } from '@app/modules/time/core/timespan.enum'
import { UIModule } from '@app/modules/ui/ui.module'
import { UrlBlobCachePipe } from '@app/modules/upload/pipes/url-blob-cache.pipe'

@Component({
  selector: 'sb-message-photo',
  templateUrl: './message-photo.component.html',
  styleUrls: ['./message-photo.component.scss'],
  imports: [CommonModule, UIModule, UrlBlobCachePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessagePhotoComponent {
  readonly conversationStore = inject(ConversationStore)
  private readonly conversationUIService = inject(ConversationUIService)
  private readonly injector = inject(Injector)
  readonly elementRef = inject(ElementRef)

  readonly Timespan = Timespan

  @Input({ required: true }) message!: Message & { type: 'photo' }
  @Input({ required: true }) conversation!: Conversation

  onPhotoDisapprovedClick(): void {
    this.conversationUIService.openDisapprovedPhotoModal(1, this.conversation, this.injector)
  }

  onPhotoPendingClick(): void {
    this.conversationUIService.openMessagePhotoAlbumModal(
      { initialSection: 'pending', conversation: this.conversation },
      this.injector,
    )
  }

  expiresInClass(expiresIn: number): string | undefined {
    if (expiresIn < 12 * Timespan.Hour) {
      return 'color-red'
    }
    if (expiresIn >= 12 * Timespan.Hour && expiresIn < 24 * Timespan.Hour) {
      return 'color-orange'
    }
    if (expiresIn >= 24 * Timespan.Hour) {
      return 'color-white'
    }

    return undefined
  }
}
